import React from "react";
import CountriesVisited from "@features/port-security/components/occupation-info/CountriesVisited.tsx";
import CountriesWorkedIn from "@features/port-security/components/occupation-info/CountriesWorkedIn.tsx";
import ParticularsOfVehicle from "@features/port-security/components/occupation-info/ParticularsOfVehicle.tsx";
import PreviousOccupations from "@features/port-security/components/occupation-info/PreviousOccupations.tsx";

const OccupationInfoForm: React.FC = () => {
  return (
    <div data-testid="occupation-info-form" className="flex flex-col gap-8">
      <PreviousOccupations />
      <CountriesVisited />
      <CountriesWorkedIn />
      <ParticularsOfVehicle />
    </div>
  );
};

export default OccupationInfoForm;
